import type { Route } from "./lib/router";
import { features } from "./lib/features";
import { IndexPage } from "./routes/index";
import { DailyChallengePage } from "./routes/daily";
import { DuelsPage } from "./routes/duels";
import { WikiPartyPage } from "./routes/wikiparty.$lobbyId";
import { OpenLobbyGamePage } from "./routes/openlobby.$lobbyId.game";
import { OpenLobbyScorePage } from "./routes/openlobby.$lobbyId.score";
import { AccountPage } from "./routes/account";
import { LoginPage } from "./routes/login";
import { AdminPage } from "./routes/admin";

export const routes: Route[] = [
  { path: "/", Page: IndexPage },
  { path: "/login", Page: LoginPage },
  { path: "/account", Page: AccountPage },
  { path: "/admin", Page: AdminPage },
  { path: "/daily", Page: DailyChallengePage },
  { path: "/daily/:lobbyId", redirect: "/daily" },
  ...(features.duels ? [{ path: "/duels", Page: DuelsPage }] : []),
  { path: "/wikiparty/:lobbyId", Page: WikiPartyPage },
  ...(features.openLobby
    ? [
        { path: "/openlobby/:lobbyId/game", Page: OpenLobbyGamePage },
        { path: "/openlobby/:lobbyId/score", Page: OpenLobbyScorePage },
      ]
    : []),
  { path: "*", Page: IndexPage },
];
